
/**
 * @typedef {{apiKey:string,customerSource:string,customerSourceName:string, defaultWorkSpaceId:string}} AppSettings
 */

/**
 * @abstract
 */
export class SettingsRepository {

    /**
     * @abstract
     * @return {AppSettings}
     */
    get() {
        throw new Error("Method get is not implemented.");
    }

    /**
     * @abstract
     * @param {AppSettings} settings
     * @return void
     */
    save(settings) {
        throw new Error("Method set is not implemented.");
    }

}